import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Input, { InputTypes } from '../input/input';
import useTranslation from '../../../utils/translation-utils';

const SEARCH_DELAY = 500;

const SearchInput = React.forwardRef(({
  className, label, value, placeholder, onChange, onApply,
}, ref) => {
  const timer = useRef();
  const [getTranslation] = useTranslation();
  const [timerCompleted, setTimerCompleted] = useState(false);

  useEffect(() => {
    if (timerCompleted) {
      onApply();
      setTimerCompleted(false);
    }
  }, [timerCompleted]);

  const handleSearchAction = () => {
    clearTimeout(timer.current);
    setTimerCompleted(true);
  };

  const handleSearchChange = (e) => {
    onChange(e);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      handleSearchAction();
    }, SEARCH_DELAY);
  };

  return (
    <Input
      value={value}
      label={label}
      className={className}
      type={InputTypes.SEARCH}
      placeholder={getTranslation(placeholder)}
      onChange={handleSearchChange}
      searchAction={handleSearchAction}
      ref={ref}
    />
  );
});

SearchInput.defaultProps = {
  className: 'search-input',
  label: '',
  value: '',
  placeholder: 'SEARCH',
  onApply: () => {},
  onChange: () => {},
};

SearchInput.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onApply: PropTypes.func,
  onChange: PropTypes.func,
};

export default SearchInput;
